import styled from '@emotion/styled';
import { TemplateProps } from './BaseTemplate';
import { CSSObject, ThemeProps, ThemeProvider } from '@emotion/react';
import useThemeStyles from '../../lib/useThemeStyles';
import React, { memo } from 'react';
import Theme from '../Layout/Theme';
import SinglePageNav from '../SinglePageComponents/Nav/SinglePageNav';
import { Wws_Page } from '../../types/graphql';
import { useNavLink } from '../../lib/useNavLinks';
import { themeFont } from '../../lib/themeFont';
import Footer from '../Layout/Footer/Standard/Footer';
import RegistryTemplate from './RegistryTemplate';
import ThemeNextImage from '../NextImage/ThemeNextImage';

export type StandaloneRegistryTemplateProps = TemplateProps;

const HeaderWrapper = styled('div')`
  background-color: ${({ theme }: ThemeProps): string =>
    theme.colors.background};
  width: 100%;
  display: flex;
  justify-content: center;
  height: 6em;
  position: sticky;
  top: 0;
  z-index: 5;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const Header = styled('h1')`
  ${themeFont('s3')}
  margin-top: 1.75rem;
  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme.components.SiteSubtitle}
`;

const RegistrySection = styled('section')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

function StandaloneRegistryTemplate({
  themeOverride,
}: StandaloneRegistryTemplateProps) {
  const theme = useThemeStyles(themeOverride);

  const navLinkOverrides = {
    rsvpPageOverride: {
      routeName: 'rsvp',
    },
    registryPageOverride: {
      routeName: 'registry',
    },
  };
  const pages = useNavLink(navLinkOverrides);

  return (
    <ThemeProvider theme={theme}>
      <Theme footer={<Footer />}>
        <SinglePageNav pages={pages as Wws_Page[]} preferPageTitle />
        <HeaderWrapper>
          <Header>{'Registry'}</Header>
        </HeaderWrapper>
        <ThemeNextImage
          src={theme.images.top || ''}
          alt="Top Theme Image"
          mobileSrc={theme.responsiveImages?.top?.smUrl || ''}
          imageCSSObject={theme.components.TopImage}
          isTopImage
          loading="eager"
        />
        <RegistrySection id="registry">
          <RegistryTemplate standaloneNote />
        </RegistrySection>
      </Theme>
    </ThemeProvider>
  );
}

export default memo(StandaloneRegistryTemplate);
